/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetModifierGroup200ResponseModifiersInner
 */
export interface GetModifierGroup200ResponseModifiersInner {
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    priceImpact?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    organizationModifierId: string;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200ResponseModifiersInner
     */
    modifierGroupId: string;
}

/**
 * Check if a given object implements the GetModifierGroup200ResponseModifiersInner interface.
 */
export function instanceOfGetModifierGroup200ResponseModifiersInner(value: object): value is GetModifierGroup200ResponseModifiersInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('organizationModifierId' in value) || value['organizationModifierId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('modifierGroupId' in value) || value['modifierGroupId'] === undefined) return false;
    return true;
}

export function GetModifierGroup200ResponseModifiersInnerFromJSON(json: any): GetModifierGroup200ResponseModifiersInner {
    return GetModifierGroup200ResponseModifiersInnerFromJSONTyped(json, false);
}

export function GetModifierGroup200ResponseModifiersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetModifierGroup200ResponseModifiersInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'priceImpact': json['priceImpact'] == null ? undefined : json['priceImpact'],
        'organizationModifierId': json['organizationModifierId'],
        'position': json['position'],
        'modifierGroupId': json['modifierGroupId'],
    };
}

export function GetModifierGroup200ResponseModifiersInnerToJSON(json: any): GetModifierGroup200ResponseModifiersInner {
    return GetModifierGroup200ResponseModifiersInnerToJSONTyped(json, false);
}

export function GetModifierGroup200ResponseModifiersInnerToJSONTyped(value?: GetModifierGroup200ResponseModifiersInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'priceImpact': value['priceImpact'],
        'organizationModifierId': value['organizationModifierId'],
        'position': value['position'],
        'modifierGroupId': value['modifierGroupId'],
    };
}

